import React, { useState, useEffect } from 'react';
import {
    Box, Switch,
    Grid,
    Card,
    CardContent,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Paper,
    Chip,
    LinearProgress,
    IconButton,
    Button,
    CircularProgress,
    Snackbar,
    Alert,
    Modal, Pagination,
    InputLabel,
    FormControl,
    Select,
    MenuItem, TextField, Autocomplete
} from '@mui/material';
import {
    FormatListBulleted,
    FolderOpen,
    AccessTime,
    RateReview,
    CheckCircle,
    Replay,
    PauseCircle,
    ErrorOutline
} from '@mui/icons-material';

import { useNavigate } from 'react-router-dom';
import LaunchIcon from '@mui/icons-material/Launch';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import VerifiedIcon from '@mui/icons-material/Verified';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import AssignmentIcon from '@mui/icons-material/Assignment'; // Added for All Tasks icon
import CreateTask from './CreateTask';
// import ManagerTasks from '../backups/ManagerTasks';
import axios from 'axios';
import { axiosInstance, localAxiosGet } from '../../../Axios/axios';
import { Loader } from '../../../components/loade';
import TaskDetails from '../Backups/TaskDetails';
import TokenExpirePopup from '../../../components/TokenExpirePopup';
import MyTasks from '../../Employee/Tasks/MyTasks';


const statusColors = {
    'Open': 'rgba(3, 169, 244, 0.1)',
    'In Progress': 'rgba(59, 130, 246, 0.1)',
    // 'Submit For Review': 'rgba(255, 159, 0, 0.1)',
    'Completed': 'rgba(34, 197, 94, 0.1)',
    'Re Open': 'rgba(156, 39, 176, 0.1)',
    'Hold': 'rgba(158, 158, 158, 0.1)',
    'Overdue': 'rgba(239, 68, 68, 0.1)',
};

const statusTextColors = {
    'Open': '#03a9f4',
    'In Progress': '#3b82f6',
    // 'Submit For Review': '#ff9f00',
    'Completed': '#22c55e',
    'Re Open': '#9c27b0',
    'Hold': '#757575',
    'Overdue': '#ef4444',
};

const formatTime = (hoursDecimal) => {
    if (hoursDecimal === null || hoursDecimal === undefined || hoursDecimal === '') {
        return '--:--'; 
    }
    
    // Convert decimal hours to total minutes
    const totalMinutes = hoursDecimal * 60;
    let hours = Math.floor(totalMinutes / 60);
    let minutes = Math.round(totalMinutes % 60);
    
    // Handle case where minutes round up to 60
    if (minutes === 60) {
        hours += 1;
        minutes = 0;
    }
    
    return `${hours} hrs ${minutes.toString().padStart(2, '0')} mins`;
}
const TasksPage = ({ 
    onBackClick, 
    onTaskSelect, 
    projectId, 
    taskFilters = {}, 
    setTaskFilters = () => {}, 
    statusCardCounts = {}, 
    setStatusCardCounts = () => {} 
}) => {
    const [showMyTasks, setShowMyTasks] = useState(false);
    const [taskDeleted, setTaskDeleted] = useState(false);
    const navigate = useNavigate();
    const [isCreateTaskOpen, setIsCreateTaskOpen] = useState(false);
    const [openTokenExpirePopup, setOpenTokenExpirePopup] = useState(false);
    console.log('projectId', projectId);
    const [showMyProjectsTasks, setShowMyProjectsTasks] = useState(false);
    const [allReviewTasks, setAllReviewTasks] = useState([]);
    const [allTasks, setAllTasks] = useState({
        all: [],
        'Open': [],
        'In Progress': [],
        // 'Submit For Review': [],
        'Completed': [],
        'Re Open': [],
        'Hold': [],
        'Overdue': [],
    });
    const [paginationInfo, setPaginationInfo] = useState({
        total: 0,
        totalPages: 0,
        currentPage: 1
    });
    const userId = localStorage.getItem('userId')
    const [isLoading, setIsLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success'
    });
    const [page, setPage] = useState(0);
    const [selectedTask, setSelectedTask] = useState(null);
    const [isTaskDetailsOpen, setIsTaskDetailsOpen] = useState(false);
    const accessToken = localStorage.getItem('accessToken');

    const [assignees, setAssignees] = useState([]);
    const [projects, setProjects] = useState([]);
    const [localProjectId, setLocalProjectId] = useState(projectId);
    const userType = localStorage.getItem('userType');

   // Use taskFilters from props with default values
const {
    searchTerm = '',
    selectedStatusFilter = 'all',
    selectedAssignee = '',
    selectedProject = '',
    selectedCategory = 'all',
    submittedForReview = 'all',
    rowsPerPage = 10,
    currentPage = 1,
} = taskFilters;


    const updateFilter = (key, value) => {
        setTaskFilters(prev => ({
            ...prev,
            [key]: value
        }));
    };

    useEffect(() => {
        if (projectId && projectId !== localProjectId) {
            setLocalProjectId(projectId);
            // setSelectedProject(projectId);
            updateFilter('selectedProject', projectId);
            // setPaginationInfo(prev => ({ ...prev, currentPage: 1 }));
            updateFilter('currentPage', 1);
        }
    }, [projectId]);


    // useEffect(() => {
    //     fetchTasks('', paginationInfo.currentPage, rowsPerPage);
    // }, [paginationInfo.currentPage, rowsPerPage, selectedCategory, searchTerm, selectedStatusFilter, selectedAssignee, selectedProject, localProjectId]);

    useEffect(() => {
        if (taskDeleted) {
            setSnackbar({
                open: true,
                message: 'Task deleted successfully!',
                severity: 'success'
            });
            setTaskDeleted(false);
        }
    }, [taskDeleted]);

    // useEffect(() => {
    //     fetchTasks('', paginationInfo.currentPage, rowsPerPage);
    // }, [localProjectId]);

    useEffect(() => {
        fetchTasks(
            selectedCategory === 'all' ? '' : selectedCategory,
            paginationInfo.currentPage,
            rowsPerPage,
            searchTerm,
            selectedStatusFilter,
            selectedAssignee,
            localProjectId,
            submittedForReview
        );
    }, [paginationInfo.currentPage, rowsPerPage, selectedCategory, localProjectId]);


    useEffect(() => {
        const fetchProjectsAndAssignees = async () => {
            if (!userId || !accessToken) return;


            try {
                // getAllprojectsByManagerId
                const ProjectsResponse = await axiosInstance(localAxiosGet(`/project/getAllProjectsBySupervisor/${userId}`, accessToken))
                if (ProjectsResponse.data.status === 'SUCCESS') {
                    setProjects(ProjectsResponse.data.message.data)
                } else {
                    setSnackbar({ open: true, message: '' })
                }
            } catch (error) {
                console.error("Error fetching projects:", error);
                setSnackbar({ open: true, message: 'Error connecting to server for projects', severity: 'error' });
            }

            if(userType === 'Manager') {
            try {

                const assigneeResponse = await axiosInstance(localAxiosGet(`/task/getUsersByReportingManager/${userId}`, accessToken)); // Using userId as managerId
                if (assigneeResponse.data.status === 'SUCCESS') {
                    setAssignees(assigneeResponse.data.message.data || []);
                } else {
                    setSnackbar({ open: true, message: 'Failed to fetch assignees', severity: 'error' });
                    setAssignees([]);
                }
            } catch (error) {
                console.error("Error fetching assignees:", error);
                setSnackbar({ open: true, message: 'Error connecting to server for assignees', severity: 'error' });
                setAssignees([]);
            }
        }
        }
        fetchProjectsAndAssignees();
    }, [])


    const fetchTasks = async (statusParam = '', pageNum = 1, pageSize = rowsPerPage, search = '', statusFilter = '', assigneeId = '', projectIdParam = '', submittedForReview = '') => {

        if (!searchTerm) {
            setIsLoading(true);
        }
        try {
            // let url = `/task/getAllMainTasksByManagerId/${userId}`;
            let url = `/task/getAllMainTasksBySupervisorId/${userId}`;
            const queryParams = new URLSearchParams();


            queryParams.append('page', pageNum);
            queryParams.append('limit', pageSize);

            const effectiveSearch = search !== undefined ? search : searchTerm;
            const effectiveStatusFilter = statusFilter !== undefined ? statusFilter : selectedStatusFilter;
            const effectiveAssigneeId = assigneeId !== undefined ? assigneeId : selectedAssignee;
            const effectiveProjectId = projectIdParam !== undefined ? projectIdParam : (selectedProject || localProjectId);
            const effectiveSubmittedForReviewFlag = submittedForReview === 'all' ? '' : submittedForReview


            const effectiveStatus = effectiveStatusFilter;

            if (effectiveStatus &&
                effectiveStatus.trim() !== '' &&
                effectiveStatus.toLowerCase() !== 'all') {
                queryParams.append('status', effectiveStatus);
            }

            if (effectiveSearch && effectiveSearch.length > 0 && effectiveSearch.length < 3) {
                return;
            }

            if (effectiveSearch && effectiveSearch.length >= 3) {
                queryParams.append('task_title', effectiveSearch);
            }


            if (effectiveAssigneeId && effectiveAssigneeId !== 'all') {
                queryParams.append('assignee', effectiveAssigneeId);
            }


            if (effectiveProjectId) {
                queryParams.append('project_id', effectiveProjectId);
            }
            if (effectiveSubmittedForReviewFlag) {
                const reviewValue = effectiveSubmittedForReviewFlag === 'true';
                queryParams.append('submit_for_review', reviewValue);
                queryParams.set('limit', 10000);
                queryParams.delete('page'); // Remove page param for client-side pagination
            }

            if (queryParams.toString()) {
                url += `?${queryParams.toString()}`;
            }

            console.log("Final API URL:", url);
            console.log("Query Parameters:", {
                search: effectiveSearch,
                statusFilter: effectiveStatusFilter,
                assigneeId: effectiveAssigneeId,
                projectId: effectiveProjectId,
                submit_for_review: effectiveSubmittedForReviewFlag
            });

            const response = await axiosInstance(localAxiosGet(url, accessToken));

            if (response.data.status === 'SUCCESS') {
                const tasks = response.data.message.tasks;
                const apiStatusCounts = response.data.message.status_counts;
                const pagination = {
                    total: response.data.message.total,
                    totalPages: response.data.message.totalPages,
                    currentPage: response.data.message.currentPage
                };

                const getAssignedTo = (task) => {
                    // If parent task has assignees, use them
                    if (task.assignees && task.assignees.length > 0) {
                        const names = task.assignees.map(a => `${a.first_name} ${a.last_name}`);
                        return names.length > 2 ? `${names.slice(0, 2).join(', ')} +${names.length - 2}` : names.join(', ');
                    }

                    // Collect assignees from subtasks if parent has none
                    const subtaskAssignees = [];
                    if (task.subtasks && task.subtasks.length > 0) {
                        task.subtasks.forEach(sub => {
                            if (sub.assignees && sub.assignees.length > 0) {
                                sub.assignees.forEach(a => {
                                    const fullName = `${a.first_name} ${a.last_name}`;
                                    if (!subtaskAssignees.includes(fullName)) {
                                        subtaskAssignees.push(fullName);
                                    }
                                });
                            }
                        });
                    }

                    if (subtaskAssignees.length === 0) return "Unassigned";

                    return subtaskAssignees.length > 2
                        ? `${subtaskAssignees.slice(0, 2).join(', ')} +${subtaskAssignees.length - 2}`
                        : subtaskAssignees.join(', ');
                };

                const parseFakeDecimalTime = (decimalHours) => {
                    const [hoursStr, minutesStrRaw = '0'] = decimalHours.toString().split('.');
                    const hours = parseInt(hoursStr, 10);
                    const minutes = parseInt(minutesStrRaw.padEnd(2, '0'), 10); // treat .2 as 20, .03 as 3
                    return { hours, minutes };
                };


                const formattedTasks = tasks.map(task => {

                    return {
                        id: task.task_id,
                        title: task.task_title,
                        deadline: new Date(task.due_date).toLocaleDateString(),
                        createdDate:new Date(task.createdAt).toLocaleDateString(),
                        priority: task.priority,
                        assignedTo: getAssignedTo(task),
                        project: task.project_name,
                        progress: task.progress,
                        status: task.status,
                        // task_status: task.task_status,
                        description: task.description,
                        startDate: new Date(task.start_date).toLocaleDateString(),
                        submit_for_review: task.submit_for_review,
                        task_type: task.task_type,
                        development_type: task.development_type,
                        assign_type: task.assign_type,
                        estimated_hours: task.estimated_hours,
                        actual_hours: task.actual_hours
                    };
                });

                if (effectiveSubmittedForReviewFlag && effectiveSubmittedForReviewFlag !== 'all') {
                    setAllReviewTasks(formattedTasks);

                    const startIndex = (pageNum - 1) * pageSize;
                    const endIndex = startIndex + pageSize;
                    const paginatedTasks = formattedTasks.slice(startIndex, endIndex);

                    const categoryKeyToUpdate = statusParam || 'all';
                    setAllTasks(prevAllTasks => ({
                        ...prevAllTasks,
                        [categoryKeyToUpdate]: paginatedTasks,
                    }));

                    setPaginationInfo({
                        total: formattedTasks.length,
                        totalPages: Math.ceil(formattedTasks.length / pageSize),
                        currentPage: pageNum
                    })
                } else {

                    const categoryKeyToUpdate = statusParam || 'all';
                    setAllTasks(prevAllTasks => ({
                        ...prevAllTasks,
                        [categoryKeyToUpdate]: formattedTasks,
                    }));
                    setStatusCardCounts(apiStatusCounts);
                    setPaginationInfo(pagination);
                }
                return { success: true, pagination };
            } else {
                setSnackbar({
                    open: true,
                    message: 'Failed to fetch tasks',
                    severity: 'error'
                });
                return { success: false, error: 'Failed to fetch tasks' };
            }
        } catch (error) {
            console.error("Error fetching project data:", error);
            setSnackbar({
                open: true,
                message: 'Error connecting to server',
                severity: 'error'
            });
            return { success: false, error: 'Error connecting to server' };
        } finally {
            if (!searchTerm) {
                setTimeout(() => {
                    setIsLoading(false);
                }, 1000);
            }
        }
    };



    const currentTasks = allTasks[selectedCategory] || [];

    const handlePaginationChange = async (event, page) => {
        setPaginationInfo(prev => ({ ...prev, currentPage: page }));

        if (submittedForReview !== 'all' & allReviewTasks.length > 0) {
            const startIndex = (page - 1) * rowsPerPage;
            const endIndex = startIndex + rowsPerPage;
            const paginatedTasks = allReviewTasks.slice(startIndex, endIndex);

            const categoryKeyToUpdate = selectedCategory === 'all' ? 'all' : selectedCategory;
            setAllTasks(prevAllTasks => ({
                ...prevAllTasks,
                [categoryKeyToUpdate]: paginatedTasks
            }))
        } else {

            fetchTasks(
                selectedCategory === 'all' ? '' : selectedCategory,
                page,
                rowsPerPage,
                searchTerm,
                selectedStatusFilter,
                selectedAssignee,
                selectedProject,
                submittedForReview
            );
        }
    };

    const handleRowsPerPageChange = (event) => {
        const newRowsPerPage = event.target.value;
        // setRowsPerPage(newRowsPerPage);
        updateFilter('rowsPerPage ', newRowsPerPage);
        // setPaginationInfo(prev => ({ ...prev, currentPage: 1 }));
        updateFilter('currentPage', 1);

        fetchTasks(
            selectedCategory === 'all' ? '' : selectedCategory,
            1,
            newRowsPerPage,
            searchTerm,
            selectedStatusFilter,
            selectedAssignee,
            selectedProject,
            submittedForReview
        );
    };

    const cardData = [
        {
            key: 'all',
            title: 'All Tasks',
            count: statusCardCounts?.total_task_count || 0,
            gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            icon: <FormatListBulleted size={32} />
        },
        {
            key: 'Open',
            title: 'Open',
            count: statusCardCounts?.Open || 0,
            gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
            icon: <FolderOpen size={32} />
        },
        // 
        {
            key: 'In Progress',
            title: 'In Progress',
            count: statusCardCounts?.['In Progress'] || 0,
            gradient: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
            icon: <RateReview size={32} />
        },
        {
            key: 'Completed',
            title: 'Completed',
            count: statusCardCounts?.Completed || 0,
            gradient: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
            icon: <CheckCircle size={32} />
        }
    ];

    const handleAssigneeFilterChange = (value) => {
        const newAssignee = value;
        // setSelectedAssignee(newAssignee);
        updateFilter('selectedAssignee', newAssignee)
        // setPaginationInfo(prev => ({ ...prev, currentPage: 1 }));
        updateFilter('currentPage', 1);

        fetchTasks(
            selectedCategory === 'all' ? '' : selectedCategory,
            1,
            rowsPerPage,
            searchTerm,
            selectedStatusFilter,
            newAssignee,
            selectedProject,
            submittedForReview
        );
    };

    const handleProjectChange = (value) => {
        const newProject = value;
        // setSelectedProject(newProject);
        updateFilter('selectedProject', newProject)
        setLocalProjectId(newProject); // Also update localProjectId
        // setPaginationInfo(prev => ({ ...prev, currentPage: 1 }));
        updateFilter('currentPage', 1);

        fetchTasks(
            selectedCategory === 'all' ? '' : selectedCategory,
            1,
            rowsPerPage,
            searchTerm,
            selectedStatusFilter,
            selectedAssignee,
            newProject,
            submittedForReview
        );
    };


    const handleStatusFilterChange = (event) => {
        const newStatus = event.target.value;
        // setSelectedStatusFilter(newStatus);
        updateFilter('selectedStatusFilter', newStatus)
        // setPaginationInfo(prev => ({ ...prev, currentPage: 1 }));
        updateFilter('currentPage', 1);

        // Pass the new status directly
        fetchTasks(
            selectedCategory === 'all' ? '' : selectedCategory,
            1,
            rowsPerPage,
            searchTerm,
            newStatus,
            selectedAssignee,
            selectedProject,
            submittedForReview
        );
    };
    const handleSubmittedForReviewChange = (event) => {
        const newValue = event.target.value;
        // setSubmittedForReview(newValue);
        updateFilter('submittedForReview', newValue)
        setAllReviewTasks([])// Clear cache when changing
        // setPaginationInfo(prev => ({ ...prev, currentPage: 1 }));
        updateFilter('currentPage', 1);
        // Pass the new status directly
        fetchTasks(
            selectedCategory === 'all' ? '' : selectedCategory,
            1,
            rowsPerPage,
            searchTerm,
            selectedStatusFilter,
            selectedAssignee,
            selectedProject,
            newValue
        );
    }
    const handleSearchChange = (event) => {
        const newSearchTerm = event.target.value;
        updateFilter('searchTerm', newSearchTerm);
        // setPaginationInfo(prev => ({ ...prev, currentPage: 1 }));
        updateFilter('currentPage', 1);

        if (newSearchTerm.length === 0 || newSearchTerm.length >= 3) {
            fetchTasks(
                selectedCategory === 'all' ? '' : selectedCategory,
                1,
                rowsPerPage,
                newSearchTerm,
                selectedStatusFilter,
                selectedAssignee,
                selectedProject,
                submittedForReview
            );
        }
    };

    const handleCardClick = (key) => {
        updateFilter('selectedCategory', key);
        const statusFilterValue = key === 'all' ? 'all' : key;
        updateFilter('selectedStatusFilter', statusFilterValue)
        // setPaginationInfo(prev => ({ ...prev, currentPage: 1 }));
        updateFilter('currentPage', 1);

        fetchTasks(
            key === 'all' ? '' : key,
            1,
            rowsPerPage,
            searchTerm,
            statusFilterValue,
            selectedAssignee,
            selectedProject,
            submittedForReview
        );
    };
    const clearAllFilters = () => {
        setTaskFilters({
            searchTerm: '',
            selectedStatusFilter: 'all',
            selectedAssignee: '',
            selectedProject: '',
            selectedCategory: 'all',
            submittedForReview: 'all',
            currentPage: 1,
            rowsPerPage: rowsPerPage
        });
        setLocalProjectId('');
        setAllReviewTasks([]);
        fetchTasks('', 1, rowsPerPage, '', 'all', '', '');
    };
    const hasActiveFilters = () => {
        return searchTerm || selectedStatusFilter || selectedAssignee || selectedProject || localProjectId || selectedCategory !== 'all';
    };
    const handleBackToTasks = () => {
        setShowMyTasks(false);
    };

    const handleCreateTaskClose = (newTask) => {
        setIsCreateTaskOpen(false);
        if (newTask && newTask.id) {
            fetchTasks();

        }
    };
   


    const handleCreateTask = () => {
        setIsCreateTaskOpen(true);
    };

    const handleMyTasksClick = () => {
        setShowMyTasks(true);
    };

    const handleCloseTokenExpirePopup = () => {
        setOpenTokenExpirePopup(false);
        navigate('/');
    };
    const handleSnackbarClose = () => {
        setSnackbar({ ...snackbar, open: false });
    };


    // if (showMyTasks) {
    //     return (
    //         <Box sx={{ p: 3 }}>
    //             <Box sx={{
    //                 display: 'flex',
    //                 alignItems: 'center',
    //                 mb: 4
    //             }}>
    //                 <Button
    //                     onClick={handleBackToTasks}
    //                     sx={{
    //                         background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
    //                         color: 'white',
    //                         borderRadius: '12px',
    //                         padding: '8px 16px',
    //                         textTransform: 'none',
    //                         fontWeight: '600',
    //                         '&:hover': {
    //                             background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
    //                         }
    //                     }}
    //                 >
    //                     Back to Tasks
    //                 </Button>
    //             </Box>
    //             <ManagerTasks />
    //         </Box>
    //     );
    // }

    if (isCreateTaskOpen) {
        return <CreateTask onClose={handleCreateTaskClose} />;
    }

    const handleTaskDetailsClick = (taskId) => {
        setSelectedTask(taskId);
        setIsTaskDetailsOpen(true);
        if (onTaskSelect) {
            onTaskSelect(taskId);
        }
    }

    const handleTaskDetailsClose = (wasDeleted = false) => {
        setIsTaskDetailsOpen(false);
        setSelectedTask(null);

        if (wasDeleted) {
            setTaskDeleted(true);
            // Refresh the task list
            fetchTasks(
                selectedCategory === 'all' ? '' : selectedCategory,
                paginationInfo.currentPage,
                rowsPerPage,
                searchTerm,
                selectedStatusFilter,
                selectedAssignee,
                selectedProject,
                submittedForReview
            );
        }
    };


    return (
        <>
            {isLoading && (
                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "rgba(0, 0, 0, 0.7)",
                        zIndex: 1000,
                        backdropFilter: "blur(3px)",
                    }}
                >
                    <Loader />
                </Box>
            )}
            <Box sx={{ p: 3, position: 'relative' }}>

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 4,
                    width: '100%' // Ensure full width
                }}>
                    {/* This empty Box acts as a spacer to push content to the right */}
                    <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                        {!showMyProjectsTasks && (
                            <Typography
                                variant="h5"
                                sx={{
                                    fontWeight: 600,
                                    color: '#1e293b'
                                }}
                            >
                                Tasks Overview
                            </Typography>
                        )}
                    </Box>

                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 3
                    }}>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            p: 1,
                            borderRadius: 2,
                            transition: 'all 0.3s ease'
                        }}>
                            <Typography
                                sx={{
                                    mr: 1,
                                    color: showMyProjectsTasks ? '#64748b' : '#3b82f6',
                                    fontWeight: showMyProjectsTasks ? 400 : 600,
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                All
                            </Typography>
                            <Switch
                                checked={showMyProjectsTasks}
                                onChange={() => setShowMyProjectsTasks(!showMyProjectsTasks)}
                                color="primary"
                            />
                            <Typography
                                sx={{
                                    ml: 1,
                                    color: showMyProjectsTasks ? '#3b82f6' : '#64748b',
                                    fontWeight: showMyProjectsTasks ? 600 : 400,
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                My Tasks
                            </Typography>
                        </Box>

                        <Button
                            variant="contained"
                            startIcon={
                                <AddIcon sx={{
                                    transition: 'transform 0.3s ease',
                                    transform: 'rotate(0deg)',
                                    '.MuiButton-root:hover &': {
                                        transform: 'rotate(90deg)'
                                    }
                                }} />
                            }
                            onClick={handleCreateTask}
                            sx={{
                                background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                                textTransform: 'none',
                                borderRadius: '12px',
                                padding: '10px 20px',
                                boxShadow: '0 4px 6px -1px rgba(59, 130, 246, 0.2), 0 2px 4px -1px rgba(59, 130, 246, 0.1)',
                                fontWeight: '600',
                                fontSize: '0.95rem',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
                                    boxShadow: '0 8px 12px -1px rgba(59, 130, 246, 0.2), 0 4px 8px -1px rgba(59, 130, 246, 0.1)',
                                    transform: 'translateY(-2px)',
                                },
                                '&:active': {
                                    transform: 'translateY(0)',
                                    boxShadow: '0 2px 4px -1px rgba(59, 130, 246, 0.2), 0 1px 2px -1px rgba(59, 130, 246, 0.1)',
                                },
                                position: 'relative',
                                overflow: 'hidden',
                                '&::before': {
                                    content: '""',
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    background: 'linear-gradient(rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0))',
                                    transform: 'translateY(-100%)',
                                    transition: 'transform 0.3s ease',
                                },
                                '&:hover::before': {
                                    transform: 'translateY(0)',
                                }
                            }}
                        >
                            Create Task
                        </Button>
                    </Box>
                </Box>

                {showMyProjectsTasks ? (
                    <Box sx={{ mt: '-70px' }}>
                        <MyTasks />
                    </Box>

                ) : (
                    <>
                        <Grid container spacing={3} sx={{ mb: 4 }}>
                            {cardData.map((card) => (
                                <Grid item xs={12} sm={4} md={3} key={card.title}>
                                    <Card
                                        onClick={() => handleCardClick(card.key)}
                                        sx={{
                                            background: selectedCategory === card.key
                                                ? `linear-gradient(145deg, ${card.gradient}10, white)`
                                                : 'white',
                                            borderRadius: '20px',
                                            position: 'relative',
                                            minHeight: '140px',
                                            border: selectedCategory === card.key
                                                ? `2px solid ${card.gradient}`
                                                : '2px solid transparent',
                                            transition: 'all 0.3s ease',
                                            cursor: 'pointer',
                                            overflow: 'hidden',
                                            boxShadow: selectedCategory === card.key
                                                ? `0 10px 30px ${card.gradient}30`
                                                : '0 4px 6px rgba(0, 0, 0, 0.02)',
                                            '&:hover': {
                                                transform: 'translateY(-5px)',
                                                boxShadow: `0 20px 40px ${card.gradient}20`,
                                                '& .card-count': {
                                                    transform: 'scale(1.1)',
                                                    color: card.gradient
                                                }
                                            }
                                        }}
                                    >
                                        <CardContent sx={{ p: 2.5 }}>
                                            <Box sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1.5,
                                                mb: 2
                                            }}>
                                                <Box sx={{
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: '12px',
                                                    background: card.gradient,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    boxShadow: `0 4px 8px ${card.gradient}40`
                                                }}>
                                                    {React.cloneElement(card.icon, {
                                                        sx: { fontSize: 22, color: 'white' }
                                                    })}
                                                </Box>
                                                <Typography sx={{
                                                    fontSize: '1rem',
                                                    fontWeight: 600,
                                                    color: '#1e293b'
                                                }}>
                                                    {card.title}
                                                </Typography>
                                            </Box>
                                            <Box sx={{
                                                display: 'flex',
                                                alignItems: 'flex-end',
                                                justifyContent: 'space-between'
                                            }}>
                                                <Typography
                                                    className="card-count"
                                                    sx={{
                                                        fontSize: '2.5rem',
                                                        fontWeight: 700,
                                                        color: '#0f172a',
                                                        lineHeight: 1,
                                                        transition: 'all 0.3s ease'
                                                    }}
                                                >
                                                    {card.count}
                                                </Typography>
                                                {selectedCategory === card.key && (
                                                    <Box sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 1,
                                                        background: `${card.gradient}15`,
                                                        py: 0.5,
                                                        px: 1.5,
                                                        borderRadius: '20px'
                                                    }}>
                                                        <Box sx={{
                                                            width: 6,
                                                            height: 6,
                                                            borderRadius: '50%',
                                                            background: card.gradient
                                                        }} />
                                                        <Typography sx={{
                                                            fontSize: '0.75rem',
                                                            fontWeight: 600,
                                                            color: card.gradient
                                                        }}>
                                                            Active
                                                        </Typography>
                                                    </Box>
                                                )}
                                            </Box>
                                            <Box sx={{ mt: 2 }}>
                                                <LinearProgress
                                                    variant="determinate"
                                                    value={selectedCategory === card.key ? 100 : 0}
                                                    sx={{
                                                        height: 4,
                                                        borderRadius: 2,
                                                        backgroundColor: '#f1f5f9',
                                                        '& .MuiLinearProgress-bar': {
                                                            background: card.gradient,
                                                            transition: 'transform 0.4s ease'
                                                        }
                                                    }}
                                                />
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>


                        <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap', alignItems: 'center' }}>
                            <TextField
                                label='Search by Task Name'
                                variant='outlined'
                                value={searchTerm}
                                onChange={(event) => handleSearchChange(event)}
                                sx={{ minWidth: 200 }}
                            />

                            <FormControl variant='outlined' sx={{ minWidth: 180 }}>
                                <InputLabel>Status</InputLabel>
                                <Select
                                    value={selectedStatusFilter}
                                    onChange={(event) => handleStatusFilterChange(event)}
                                    label="Status"
                                >
                                    <MenuItem value="all">All</MenuItem>
                                    {Object.keys(statusCardCounts).filter(key => key !== 'total_task_count').map((statusKey) => (
                                        <MenuItem key={statusKey} value={statusKey}>
                                            {statusKey}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            {userType === 'Manager' && (
                            <FormControl variant='outlined' sx={{ minWidth: 180 }}>
                                <Autocomplete
                                    options={assignees || []}
                                    getOptionLabel={(assignee) => `${assignee.first_name} ${assignee.last_name}`}
                                    value={assignees?.find(assignee => assignee.id === selectedAssignee) || null}
                                    onChange={(event, newValue) => {
                                        handleAssigneeFilterChange(newValue ? newValue.id : 'all');
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Assignee"
                                            variant="outlined"
                                        />
                                    )}
                                    filterOptions={(options, { inputValue }) => {
                                        // Filter options based on first letter or any part of the name
                                        return options.filter(option =>
                                            `${option.first_name} ${option.last_name}`
                                                .toLowerCase()
                                                .includes(inputValue.toLowerCase())
                                        );
                                    }}
                                    autoHighlight
                                    clearOnBlur
                                    handleHomeEndKeys
                                />
                            </FormControl>
                            )}

                            <FormControl variant='outlined' sx={{ minWidth: 180 }}>
                                <Autocomplete
                                    options={projects || []}
                                    getOptionLabel={(project) => project.project_title || ''}
                                    value={projects?.find(project => project.id === (selectedProject || localProjectId)) || null}
                                    onChange={(event, newValue) => {
                                        handleProjectChange(newValue ? newValue.id : '');
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Project Name"
                                            variant="outlined"
                                        />
                                    )}
                                    filterOptions={(options, { inputValue }) => {
                                        // Filter projects based on first letter or any part of the project title
                                        return options.filter(option =>
                                            option.project_title
                                                .toLowerCase()
                                                .includes(inputValue.toLowerCase())
                                        );
                                    }}
                                    autoHighlight
                                    clearOnBlur
                                    handleHomeEndKeys
                                />
                            </FormControl>
                            <FormControl variant='outlined' sx={{ minWidth: 180 }}>
                                <InputLabel>Submitted for Review</InputLabel>
                                <Select
                                    value={submittedForReview}
                                    onChange={(event) => handleSubmittedForReviewChange(event)}
                                    label='Submitted For Review'
                                >
                                    <MenuItem value='all'>All</MenuItem>
                                    <MenuItem value='true'>Yes</MenuItem>
                                    <MenuItem value='false'>No</MenuItem>

                                </Select>
                            </FormControl>



                            {hasActiveFilters() && (
                                <Button
                                    variant="outlined"
                                    onClick={clearAllFilters}
                                    sx={{
                                        borderColor: '#ef4444',
                                        color: '#ef4444',
                                        borderRadius: '8px',
                                        textTransform: 'none',
                                        fontWeight: 600,
                                        padding: '8px 16px',
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            backgroundColor: '#ef4444',
                                            color: 'white',
                                            borderColor: '#ef4444',
                                        }
                                    }}
                                >
                                    Clear Filters
                                </Button>

                            )}
                        </Box>

                        <Box sx={{ borderRadius: '12px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)', overflow: 'hidden' }}>
                            <TableContainer component={Paper} sx={{ borderRadius: '12px 12px 0 0' }}>
                                <Table>
                                    <TableHead>
                                        <TableRow sx={{ background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)' }}>
                                            <TableCell sx={{ color: 'white', fontWeight: 700 }}>Task Name</TableCell>
                                            <TableCell sx={{ color: 'white', fontWeight: 700 }}>Project</TableCell>
                                            <TableCell sx={{ color: 'white', fontWeight: 700 }}>Assigned To</TableCell>
                                            <TableCell sx={{ color: 'white', fontWeight: 700 }}>created Date</TableCell>
                                            <TableCell sx={{ color: 'white', fontWeight: 700 }}>Deadline</TableCell>
                                            <TableCell sx={{ color: 'white', fontWeight: 700 }}>Priority</TableCell>
                                            <TableCell sx={{ color: 'white', fontWeight: 700 }}>Estimated Hours</TableCell>
                                            <TableCell sx={{ color: 'white', fontWeight: 700 }}>Actual Hours</TableCell>
                                            <TableCell sx={{ color: 'white', fontWeight: 700 }}>Status</TableCell>
                                            {/* <TableCell sx={{ color: 'white', fontWeight: 700, whiteSpace: 'nowrap' }}>Progress %</TableCell> */}
                                            <TableCell sx={{ color: 'white', fontWeight: 700 }}>Ready for Review</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {isLoading ? (
                                            <TableRow>
                                                <TableCell colSpan={8} align="center">
                                                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                                                        <CircularProgress size={40} sx={{ color: '#3b82f6' }} />
                                                    </Box>
                                                    <Typography sx={{ textAlign: 'center', color: '#64748b' }}>
                                                        Loading tasks...
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ) : allTasks[selectedCategory].length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={8} align="center">
                                                    <Typography sx={{ py: 3, color: '#64748b' }}>
                                                        No tasks found For this Status
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            currentTasks.map((task, index) => (
                                                <TableRow key={task.id} sx={{
                                                    backgroundColor: index % 2 === 0 ? '#f8fafc' : 'white',
                                                    '&:hover': {
                                                        backgroundColor: '#f1f5f9'
                                                    },
                                                    cursor: 'pointer'
                                                }}
                                                    onClick={() => handleTaskDetailsClick(task.id)}
                                                >
                                                    <TableCell sx={{ fontWeight: '600', fontSize: '14px', wordWrap: 'break-word' }}>
                                                        {task.title}
                                                    </TableCell>
                                                    <TableCell sx={{ fontWeight: '600', fontSize: '13px', wordWrap: 'break-word' }}>
                                                        {task.project}
                                                    </TableCell>
                                                    <TableCell>{task.assignedTo}</TableCell>
                                                    <TableCell>{task.createdDate}</TableCell>
                                                    <TableCell>{task.deadline}</TableCell>
                                                    <TableCell>
                                                        <Chip
                                                            label={task.priority}
                                                            sx={{
                                                                backgroundColor:
                                                                    task.priority === 'High' ? 'rgba(239, 68, 68, 0.2)' :
                                                                        task.priority === 'Medium' ? 'rgba(234, 179, 8, 0.2)' :
                                                                            'rgba(34, 197, 94, 0.2)',
                                                                color:
                                                                    task.priority === 'High' ? '#ef4444' :
                                                                        task.priority === 'Medium' ? '#eab308' :
                                                                            '#22c55e',
                                                                fontWeight: 600
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell>{formatTime(task.estimated_hours)}</TableCell>
                                                    <TableCell>{formatTime(task.actual_hours)}</TableCell>
                                                    <TableCell>
                                                        <Chip
                                                            label={task.status}
                                                            sx={{
                                                                backgroundColor: statusColors[task.status] || statusColors.Hold,
                                                                color: statusTextColors[task.status] || statusTextColors.Hold,
                                                                fontWeight: 600,
                                                            }}
                                                        />
                                                    </TableCell>
                                                    {/* <TableCell>
                                                        <Box sx={{ position: 'relative', width: '100%' }}>
                                                            <LinearProgress
                                                                variant="determinate"
                                                                value={task.progress}
                                                                sx={{
                                                                    height: 8,
                                                                    borderRadius: 4,
                                                                    backgroundColor: 'rgba(59, 130, 246, 0.2)',
                                                                    '& .MuiLinearProgress-bar': {
                                                                        background: 'linear-gradient(90deg, #3b82f6, #2563eb)',
                                                                        borderRadius: 4
                                                                    }
                                                                }}
                                                            />
                                                            <Typography
                                                                variant="caption"
                                                                sx={{
                                                                    position: 'absolute',
                                                                    right: '-30px',
                                                                    top: '-4px',
                                                                    color: '#3b82f6',
                                                                    fontWeight: 600
                                                                }}
                                                            >
                                                                {task.progress}%
                                                            </Typography>
                                                        </Box>
                                                    </TableCell> */}

                                                    <TableCell sx={{ textAlign: 'center' }}>
                                                        {task.submit_for_review}
                                                        <IconButton>
                                                            <VerifiedIcon style={{ color: task.submit_for_review ? '#FFBF00' : 'grey' }} />
                                                        </IconButton>
                                                    </TableCell>
                                                    {/* <TableCell>
                                <IconButton 
                                    onClick={(e) => handleEdit(e, task.id)} 
                                    sx={{ color: '#eab308' }}
                                >
                                    <EditIcon />
                                </IconButton>
                                <IconButton 
                                    onClick={(e) => handleDelete(e, task.id)} 
                                    sx={{ color: '#ef4444' }}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </TableCell> */}
                                                </TableRow>
                                            ))
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'flex-end',

                                backgroundColor: '#f8fafc',
                                borderTop: '1px solid #e2e8f0',
                                p: 2
                            }}>
                                <FormControl size="small" sx={{ minWidth: 120 }}>
                                    <InputLabel>Rows per page</InputLabel>
                                    <Select
                                        value={rowsPerPage}
                                        onChange={handleRowsPerPageChange}
                                        label="Rows per page"
                                    >
                                        <MenuItem value={5}>5</MenuItem>
                                        <MenuItem value={10}>10</MenuItem>
                                        <MenuItem value={25}>25</MenuItem>
                                        <MenuItem value={50}>50</MenuItem>
                                    </Select>
                                </FormControl>
                                <Pagination
                                    count={paginationInfo.totalPages}
                                    page={paginationInfo.currentPage}
                                    onChange={handlePaginationChange}
                                    color="primary"
                                    sx={{
                                        '& .MuiPaginationItem-root': {
                                            borderRadius: '8px',
                                            '&.Mui-selected': {
                                                background: 'linear-gradient(135deg, #6366F1 0%, #A855F7 100%)',
                                                color: 'white',
                                                '&:hover': {
                                                    background: 'linear-gradient(135deg, #5B5BD6 0%, #9333EA 100%)',
                                                }
                                            },
                                            '&:not(.Mui-selected):hover': {
                                                backgroundColor: 'rgba(99, 102, 241, 0.1)',
                                            }
                                        }
                                    }}
                                />
                            </Box>
                        </Box>
                    </>
                )}
                <Modal
                    open={isTaskDetailsOpen}
                    onClose={handleTaskDetailsClose}
                    aria-labelledby="task-details-modal-title"
                >
                    <Box sx={{
                        maxWidth: 1000,
                        margin: 'auto',
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        backdropFilter: 'blur(10px)',
                        borderRadius: 3,
                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                        p: 2
                    }}
                    >
                        <TaskDetails onClose={handleTaskDetailsClose} taskId={selectedTask} onTaskDeleted={() => handleTaskDetailsClose(true)} />
                    </Box>
                </Modal>

                <Modal
                    open={openTokenExpirePopup}
                    onClose={handleCloseTokenExpirePopup}
                    aria-labelledby="token-expire-modal-title"
                    aria-describedby="token-expire-modal-description"
                >
                    <TokenExpirePopup onClose={handleCloseTokenExpirePopup} />
                </Modal>

                <Snackbar
                    open={snackbar.open}
                    autoHideDuration={6000}
                    onClose={handleSnackbarClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                >
                    <Alert
                        onClose={handleSnackbarClose}
                        severity={snackbar.severity}
                        sx={{ width: '100%' }}
                        variant="filled"
                    >
                        {snackbar.message}
                    </Alert>
                </Snackbar>
            </Box>
        </>

    );


};


export default TasksPage;